
import { z } from 'zod';

export const formSchema = z.object({
  type: z.enum(['Bug', 'Issue/Concern', 'Feature Request', 'Technique Request']),
  description: z.string().min(1, { message: 'Description is required' }),
  steps: z.string().optional(),
  urgency: z.enum(['Low', 'Medium', 'High', 'Critical']),
  contactMethod: z.enum(['Email', 'Phone', 'Either is fine', 'No need to contact me']),
  phoneNumber: z.string().optional(),
  additionalComments: z.string().optional(),
  techniqueName: z.string().optional(),
}).superRefine((data: { type: string; techniqueName?: string }, ctx: { addIssue: (issue: { code: string; message: string; path: string[] }) => void }) => {
  // Only require techniqueName when type is 'Technique Request'
  if (data.type === 'Technique Request' && (!data.techniqueName || data.techniqueName.trim() === '')) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Technique name is required for technique requests',
      path: ['techniqueName'],
    });
  }
});

export type FormValues = z.infer<typeof formSchema>;
